export const SHOW_CONNECT_MODAL = "SHOW_CONNECT_MODAL"
export const SHOW_WALLET_CONNECT_MODAL = "SHOW_WALLET_CONNECT_MODAL"
export const HIDE_MODAL = "HIDE_MODAL"
export const CONNECT_WALLET = "CONNECT_WALLET"
export const DISCONNECT_WALLET = "DISCONNECT_WALLET"